"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6526],{

/***/ 11415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34386);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6585);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49990);





var Tooltip = function(_param) {
    var title = _param.title, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "title",
        "children"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        title: title,
        arrow: true,
        placement: "top",
        TransitionComponent: _mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z,
        sx: {}
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            sx: {
                height: "fit-content"
            },
            children: children
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);


/***/ }),

/***/ 36526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ customHooks_useInvoice; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/InfoOutlined.js
var InfoOutlined = __webpack_require__(2548);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js
var Box = __webpack_require__(99226);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./mui-customs/Theme.ts
var Theme = __webpack_require__(24849);
;// CONCATENATED MODULE: ./components/containers/StyledAmountContainer.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  p:nth-child(1) {\n    color: ",
        ";\n  }\n  p:nth-child(2) {\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledAmountContainer = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(_templateObject(), Theme/* theme.grey1.400 */.r.grey1[400], Theme/* theme.black.800 */.r.black[800]);

;// CONCATENATED MODULE: ./components/containers/StyledContainer.tsx

function StyledContainer_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding: 16px;\n  background: ",
        ";\n  border-radius: 6px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  border: 0.7px solid ",
        ";\n"
    ]);
    StyledContainer_templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var StyledContainer = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(StyledContainer_templateObject(), Theme/* theme.whiteBg.WBG2 */.r.whiteBg.WBG2, Theme/* theme.whiteBg.WBG4 */.r.whiteBg.WBG4);

// EXTERNAL MODULE: ./node_modules/@hookform/resolvers/yup/dist/yup.mjs + 1 modules
var yup = __webpack_require__(47533);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(91444);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(74231);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(40570);
// EXTERNAL MODULE: ./components/TextField.tsx
var TextField = __webpack_require__(25259);
// EXTERNAL MODULE: ./components/Typography.tsx
var Typography = __webpack_require__(97734);
;// CONCATENATED MODULE: ./components/invoice/AddAndEditInvoiceLineItem.tsx













var schema = yup_es/* object */.Ry().shape({
    title: yup_es/* string */.Z_().required("Title is required"),
    rate: yup_es/* number */.Rx().test("is-decimal", "Maximum two digits after comma", function(val) {
        if (val != undefined) {
            return /^\d+(\.\d{0,2})?$/.test(val);
        }
        return true;
    }).required("Rate is required").typeError("Rate is required"),
    quantity: yup_es/* number */.Rx().min(1, "Enter a valid quantity").integer("Enter a valid quantity").required("Quantity is required").typeError("Quantity is required")
});
var AddAndEditInvoiceLineItem = function(param) {
    var enableDisplayMode = param.enableDisplayMode, invoiceData = param.invoiceData, invoiceSubmitHandler = param.invoiceSubmitHandler, handleInvoiceEdit = param.handleInvoiceEdit;
    var ref = (0,react.useState)(0), total = ref[0], setTotal = ref[1];
    var ref1 = (0,index_esm/* useForm */.cI)({
        resolver: (0,yup/* yupResolver */.X)(schema),
        defaultValues: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, invoiceData), {
            rate: "".concat(invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.rate),
            quantity: "".concat(invoiceData === null || invoiceData === void 0 ? void 0 : invoiceData.quantity)
        }),
        mode: "onChange"
    }), control = ref1.control, errors = ref1.formState.errors, reset = ref1.reset, handleSubmit = ref1.handleSubmit, getValues = ref1.getValues;
    var handleCalculateTotal = function() {
        var data = getValues();
        if (data.rate === "undefined" || data.quantity === "undefined") {
            return;
        }
        var newTotal = Math.round(parseFloat(data.rate) * parseInt(data.quantity, 10) * 100) / 100;
        setTotal(newTotal);
    };
    var handleSubmitForm = function(data) {
        if (Object.keys(errors).length > 0) {
            react_toastify_esm/* toast.error */.Am.error("Please fix the errors before submitting");
            return;
        }
        var newData = {
            title: data.title,
            rate: parseInt(data.rate, 10),
            quantity: parseInt(data.quantity, 10)
        };
        if (invoiceData) {
            enableDisplayMode && enableDisplayMode();
            handleInvoiceEdit && handleInvoiceEdit(newData);
        } else {
            invoiceSubmitHandler && invoiceSubmitHandler(newData);
            reset();
            setTotal(0);
        }
    };
    var submitForm = function(e) {
        e.preventDefault();
        handleSubmit(handleSubmitForm)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            backgroundColor: Theme/* theme.whiteBg.WBG2 */.r.whiteBg.WBG2,
            borderRadius: 2,
            p: 2,
            position: "relative"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    input: {
                        padding: "7px !important"
                    }
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    container: true,
                    spacing: 3,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                name: "title",
                                control: control,
                                render: function(param) {
                                    var field = param.field;
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        placeholder: "Example: hourly chef rate",
                                        label: "Line Item Description",
                                        isRequired: true,
                                        error: Boolean(errors.title),
                                        helperText: (ref = errors.title) === null || ref === void 0 ? void 0 : ref.message
                                    }, field), {
                                        ref: null
                                    }));
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 4,
                            md: 5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                name: "rate",
                                control: control,
                                render: function(param) {
                                    var field = param.field;
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        type: "number",
                                        label: "Rate",
                                        isRequired: true,
                                        error: Boolean(errors.rate),
                                        helperText: (ref = errors.rate) === null || ref === void 0 ? void 0 : ref.message
                                    }, field), {
                                        onChange: function(e) {
                                            field.onChange(e);
                                            handleCalculateTotal();
                                        },
                                        ref: null
                                    }));
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 4,
                            md: 5,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Controller */.Qr, {
                                name: "quantity",
                                control: control,
                                render: function(param) {
                                    var field = param.field;
                                    var ref;
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                        type: "number",
                                        label: "Quantity",
                                        isRequired: true,
                                        error: Boolean(errors.quantity),
                                        helperText: (ref = errors.quantity) === null || ref === void 0 ? void 0 : ref.message
                                    }, field), {
                                        onChange: function(e) {
                                            field.onChange(e);
                                            handleCalculateTotal();
                                        },
                                        ref: null
                                    }));
                                }
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                alignItems: "end",
                                justifyContent: "start",
                                pb: 1,
                                display: "flex"
                            },
                            item: true,
                            xs: 4,
                            md: 2,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                sx: {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    color: Theme/* theme.brand1.700 */.r.brand1[700]
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "title1",
                                        children: "Total"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                        variant: "title2",
                                        children: [
                                            "$",
                                            total
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            item: true,
                            xs: 12,
                            sx: {
                                display: "flex",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                sx: {
                                    padding: "7px",
                                    maxWidth: "176px"
                                },
                                type: "submit",
                                onClick: function(e) {
                                    return submitForm(e);
                                },
                                children: invoiceData ? "Save" : "Add"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var invoice_AddAndEditInvoiceLineItem = (AddAndEditInvoiceLineItem);

// EXTERNAL MODULE: ./node_modules/@mui/icons-material/DeleteOutlineOutlined.js
var DeleteOutlineOutlined = __webpack_require__(52778);
// EXTERNAL MODULE: ./node_modules/@mui/material/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(93946);
// EXTERNAL MODULE: ./assets/Icons/EditIcon.tsx
var EditIcon = __webpack_require__(95905);
;// CONCATENATED MODULE: ./components/invoice/DisplayInvoiceLineItem.tsx

function DisplayInvoiceLineItem_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  p:nth-child(1) {\n    color: ",
        ";\n  }\n  p:nth-child(2) {\n    color: ",
        ";\n  }\n"
    ]);
    DisplayInvoiceLineItem_templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var DisplayInvoiceLineItem_StyledContainer = (0,emotion_styled_browser_esm/* default */.Z)(Box/* default */.Z)(DisplayInvoiceLineItem_templateObject(), Theme/* theme.grey2.400 */.r.grey2[400], Theme/* theme.black.800 */.r.black[800]);
var DisplayInvoiceLineItem = function(param) {
    var handleEdit = param.handleEdit, handleDelete = param.handleDelete, invoiceData = param.invoiceData, _view = param.view, view = _view === void 0 ? false : _view;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        sx: {
            backgroundColor: view ? Theme/* theme.whiteBg.WBG3 */.r.whiteBg.WBG3 : Theme/* theme.whiteBg.WBG1 */.r.whiteBg.WBG1,
            borderRadius: 2,
            p: 2,
            my: 1,
            position: "relative"
        },
        children: [
            handleEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    position: "absolute",
                    top: 3,
                    right: 3,
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleEdit,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EditIcon/* default */.Z, {
                            color: Theme/* theme.brand1.500 */.r.brand1[500]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                        onClick: handleDelete,
                        sx: {
                            p: "6px"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteOutlineOutlined/* default */.Z, {
                            sx: {
                                color: Theme/* theme.brand2.700 */.r.brand2[700],
                                fontSize: "20px"
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body3",
                sx: {
                    color: Theme/* theme.black.800 */.r.black[800],
                    mb: 2
                },
                children: invoiceData.title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisplayInvoiceLineItem_StyledContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "small5",
                                children: "Rate"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "title2",
                                children: [
                                    "$",
                                    invoiceData.rate
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisplayInvoiceLineItem_StyledContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "small5",
                                children: "Quantity"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "title2",
                                children: invoiceData.quantity
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DisplayInvoiceLineItem_StyledContainer, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "small5",
                                children: "Total"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "title2",
                                children: [
                                    "$",
                                    invoiceData.rate * invoiceData.quantity
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var invoice_DisplayInvoiceLineItem = (DisplayInvoiceLineItem);

;// CONCATENATED MODULE: ./components/invoice/InvoiceLineItem.tsx




var InvoiceLineItem = function(param) {
    var invoiceData = param.invoiceData, handleInvoiceDelete = param.handleInvoiceDelete, handleInvoiceEdit = param.handleInvoiceEdit;
    var ref = (0,react.useState)(false), canEdit = ref[0], setCanEdit = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !canEdit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(invoice_DisplayInvoiceLineItem, {
            invoiceData: invoiceData,
            handleDelete: handleInvoiceDelete,
            handleEdit: function() {
                setCanEdit(true);
            }
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(invoice_AddAndEditInvoiceLineItem, {
            invoiceData: invoiceData,
            handleInvoiceEdit: handleInvoiceEdit,
            enableDisplayMode: function() {
                setCanEdit(false);
            }
        })
    });
};
/* harmony default export */ var invoice_InvoiceLineItem = (InvoiceLineItem);

// EXTERNAL MODULE: ./components/Tooltip.tsx
var Tooltip = __webpack_require__(11415);
// EXTERNAL MODULE: ./constants/UserType.ts
var UserType = __webpack_require__(22898);
// EXTERNAL MODULE: ./firebase/finance.ts
var finance = __webpack_require__(2876);
// EXTERNAL MODULE: ./firebase/user.ts + 3 modules
var user = __webpack_require__(32012);
// EXTERNAL MODULE: ./helper/finance.ts
var helper_finance = __webpack_require__(15044);
;// CONCATENATED MODULE: ./helper/getInvoiceItemAmount.ts
var getInvoiceItemAmount = function(lineItem) {
    return lineItem.quantity * lineItem.rate;
};
/* harmony default export */ var helper_getInvoiceItemAmount = (getInvoiceItemAmount);

// EXTERNAL MODULE: ./utils/stripe-helpers.ts
var stripe_helpers = __webpack_require__(61855);
;// CONCATENATED MODULE: ./customHooks/useInvoice.tsx
























var useInvoice = function(gigProposalData) {
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return state.user.user;
    }), uid = ref.uid, userLocation = ref.address, userType = ref.userType;
    var ref1 = (0,react.useState)({
        tax_amount: 0,
        deposit_percentage: 0,
        service_charge: 0
    }), settings = ref1[0], setSettings = ref1[1];
    (0,react.useEffect)(function() {
        var getSettings = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var settings;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!uid) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,user/* fetchUserSettings */.j_)(uid)
                            ];
                        case 1:
                            settings = _state.sent();
                            if (settings) {
                                setSettings(settings);
                            }
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getSettings() {
                return _ref.apply(this, arguments);
            };
        }();
        getSettings();
    }, [
        uid
    ]);
    var ref2 = (0,react.useState)((gigProposalData === null || gigProposalData === void 0 ? void 0 : gigProposalData.invoice) || {
        lineItems: [],
        total: 0
    }), invoice = ref2[0], setInvoiceData = ref2[1];
    (0,react.useEffect)(function() {
        (gigProposalData === null || gigProposalData === void 0 ? void 0 : gigProposalData.invoice) && setInvoiceData(gigProposalData === null || gigProposalData === void 0 ? void 0 : gigProposalData.invoice);
    }, [
        gigProposalData
    ]);
    (0,react.useEffect)(function() {
        var getTaxes = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var taxDetails;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!(uid && invoice.total > 0 && (gigProposalData === null || gigProposalData === void 0 ? void 0 : gigProposalData.id))) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,finance/* getTaxDetails */.fN)(gigProposalData === null || gigProposalData === void 0 ? void 0 : gigProposalData.id, invoice.total)
                            ];
                        case 1:
                            taxDetails = _state.sent();
                            setSettings(function(prev) {
                                var ref;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                                    tax_amount: prev.tax_amount + ((ref = taxDetails.data) === null || ref === void 0 ? void 0 : ref.taxData)
                                });
                            });
                            _state.label = 2;
                        case 2:
                            return [
                                2
                            ];
                    }
                });
            });
            return function getTaxes() {
                return _ref.apply(this, arguments);
            };
        }();
        getTaxes();
    }, [
        invoice
    ]);
    var handleInvoiceSubmit = function(data) {
        setInvoiceData(function(prevData) {
            var newData = (0,_object_spread/* default */.Z)({}, prevData);
            newData.lineItems = newData.lineItems.concat((0,_object_spread/* default */.Z)({}, data));
            newData.total += helper_getInvoiceItemAmount(data);
            newData.total = newData.total;
            return newData;
        });
    };
    var handleEditInvoiceData = function(invoiceData, index) {
        setInvoiceData(function(prevData) {
            var newData = (0,_object_spread/* default */.Z)({}, prevData);
            // Temp fix
            newData.total -= helper_getInvoiceItemAmount(newData.lineItems[index]);
            var newLineItems = (0,_to_consumable_array/* default */.Z)(newData.lineItems);
            newLineItems[index] = (0,_object_spread/* default */.Z)({}, invoiceData);
            newData.lineItems = newLineItems;
            newData.total += helper_getInvoiceItemAmount(invoiceData);
            newData.total = newData.total;
            return newData;
        });
    };
    var handleDeleteInvoiceItem = function(index) {
        setInvoiceData(function(prevInvoiceData) {
            var copyInvoiceData = (0,_object_spread/* default */.Z)({}, prevInvoiceData);
            copyInvoiceData.total -= helper_getInvoiceItemAmount(copyInvoiceData.lineItems[index]);
            copyInvoiceData.lineItems.splice(index, 1);
            return copyInvoiceData;
        });
    };
    var displayTotal = invoice.lineItems.length > 0 && settings && userType && (0,stripe_helpers/* formatAmountForDisplay */.RK)((0,helper_finance/* calculateGrossTotal */.Z4)(invoice.total, settings.tax_amount || 0, settings.service_charge, userType), "usd");
    var InvoiceComponent = function(param) {
        var _edit = param.edit, edit = _edit === void 0 ? false : _edit;
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(StyledContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body2",
                    sx: {
                        color: "".concat(Theme/* theme.grey2.500 */.r.grey2[500], " !important")
                    },
                    children: "Invoice"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        mt: 3
                    },
                    children: [
                        invoice.lineItems.map(function(lineItem, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: edit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(invoice_InvoiceLineItem, {
                                    handleInvoiceDelete: function() {
                                        handleDeleteInvoiceItem(index);
                                    },
                                    handleInvoiceEdit: function(data) {
                                        return handleEditInvoiceData(data, index);
                                    },
                                    invoiceData: lineItem
                                }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(invoice_DisplayInvoiceLineItem, {
                                    view: true,
                                    invoiceData: lineItem
                                }, index)
                            });
                        }),
                        edit ? /*#__PURE__*/ (0,jsx_runtime.jsx)(invoice_AddAndEditInvoiceLineItem, {
                            invoiceSubmitHandler: handleInvoiceSubmit
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 1,
                                px: 2
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAmountContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "2px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "small5",
                                                    children: "Subtotal"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "This is the sum of all the invoice line items.",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                        sx: {
                                                            fontSize: "14px",
                                                            color: Theme/* theme.grey2.400 */.r.grey2[400]
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "title2",
                                            children: (0,stripe_helpers/* formatAmountForDisplay */.RK)(invoice.total, "usd")
                                        })
                                    ]
                                }),
                                (settings === null || settings === void 0 ? void 0 : settings.tax_amount) != undefined ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAmountContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "2px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "small5",
                                                    children: "Tax & Fees"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "These are the applicable taxes & fees required by your state, ".concat(userLocation === null || userLocation === void 0 ? void 0 : userLocation.state, ". In ").concat(userLocation === null || userLocation === void 0 ? void 0 : userLocation.state, " it is $ ").concat(parseFloat("".concat(settings.tax_amount / 100)).toFixed(2), " ."),
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                        sx: {
                                                            fontSize: "14px",
                                                            color: Theme/* theme.grey2.400 */.r.grey2[400]
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "title2",
                                            children: [
                                                userType === UserType/* default.Chef */.Z.Chef && "-",
                                                invoice.lineItems.length > 0 && settings && (0,stripe_helpers/* formatAmountForDisplay */.RK)((0,helper_finance/* calculateTax */.km)(invoice.total, settings.tax_amount || 0) || 0, "usd")
                                            ]
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAmountContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "2px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "small5",
                                                    children: "Service Charge"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "This is the amount More Pleaze takes to run the marketplace.",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                        sx: {
                                                            fontSize: "14px",
                                                            color: Theme/* theme.grey2.400 */.r.grey2[400]
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "title2",
                                            children: [
                                                userType === UserType/* default.Chef */.Z.Chef && "-",
                                                invoice.lineItems.length > 0 && settings && (0,stripe_helpers/* formatAmountForDisplay */.RK)((0,helper_finance/* calculateServiceCharge */.ti)(invoice.total, settings.service_charge), "usd")
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledAmountContainer, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "2px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "small5",
                                                    children: "Your Total Payout"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                                                    title: "The sum of Subtotal, Tax & Fees, and Service Charge.",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoOutlined/* default */.Z, {
                                                        sx: {
                                                            fontSize: "14px",
                                                            color: Theme/* theme.grey2.400 */.r.grey2[400]
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "title2",
                                            children: displayTotal || "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return {
        InvoiceComponent: InvoiceComponent,
        invoice: invoice,
        settings: settings
    };
};
/* harmony default export */ var customHooks_useInvoice = (useInvoice);


/***/ }),

/***/ 2876:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ getTotalPendingForUser; },
/* harmony export */   "by": function() { return /* binding */ getTotalDueForUser; },
/* harmony export */   "eF": function() { return /* binding */ getTotalPaidForUser; },
/* harmony export */   "f8": function() { return /* binding */ fetchTransactionDetails; },
/* harmony export */   "fN": function() { return /* binding */ getTaxDetails; }
/* harmony export */ });
/* unused harmony export getPaymentReason */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97582);
/* harmony import */ var firebase_firestore__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41092);
/* harmony import */ var _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8573);
/* harmony import */ var _constants_UserType__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22898);
/* harmony import */ var _helper_finance__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15044);
/* harmony import */ var _types_enums__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8552);
/* harmony import */ var _utils_api_helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25159);
/* harmony import */ var _firebase__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99052);









// DUE means all
// PAID means (PENDING +  proposal.proposalHistory.previousState == ProposalState.AWAITING_PAYMENT i.e. only deposit paid) ||  (PENDING + proposal.proposalHistory.previousState == ProposalState.DEPOSIT_PAID i.e, full paid) || (DEPOSIT_PAID i.e, deposit paid) || (FINISHED_AND_PAID i.e, full paid)
var getTotalDueForUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(userId, userType, service_charge) {
        var count, coll, q, querySnapshot, coll1, q1, querySnapshot1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    count = 0;
                    if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Chef */ .Z.Chef)) return [
                        3,
                        3
                    ];
                    coll = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "proposals");
                    q = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .query */ .IO)(coll, (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("chefUid", "==", userId));
                    return [
                        4,
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDocs */ .PL)(q)
                    ];
                case 1:
                    querySnapshot = _state.sent();
                    return [
                        4,
                        Promise.all(querySnapshot.docs.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposal) {
                                var data, taxDetails, ref, ref1;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = proposal.data();
                                            return [
                                                4,
                                                fetchTransactionDetails(proposal.id)
                                            ];
                                        case 1:
                                            taxDetails = _state.sent();
                                            if (taxDetails) {
                                                ;
                                                ;
                                                count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateGrossTotal */ .Z4)((ref1 = (ref = data.invoice) === null || ref === void 0 ? void 0 : ref.total) !== null && ref1 !== void 0 ? ref1 : 0, 0.029, service_charge, userType);
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(proposal) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 3:
                    if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Client */ .Z.Client)) return [
                        3,
                        6
                    ];
                    coll1 = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "proposals");
                    q1 = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .query */ .IO)(coll1, (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("clientUid", "==", userId));
                    return [
                        4,
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDocs */ .PL)(q1)
                    ];
                case 4:
                    querySnapshot1 = _state.sent();
                    return [
                        4,
                        Promise.all(querySnapshot1.docs.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposal) {
                                var data, taxDetails, ref, ref1;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = proposal.data();
                                            return [
                                                4,
                                                fetchTransactionDetails(proposal.id)
                                            ];
                                        case 1:
                                            taxDetails = _state.sent();
                                            if (taxDetails) {
                                                ;
                                                ;
                                                count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateGrossTotal */ .Z4)((ref1 = (ref = data.invoice) === null || ref === void 0 ? void 0 : ref.total) !== null && ref1 !== void 0 ? ref1 : 0, 0.029, service_charge, userType);
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(proposal) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        count
                    ];
            }
        });
    });
    return function getTotalDueForUser(userId, userType, service_charge) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * @deprecated
 * Using Total Due and Total Paid to calculate Total Pending
 *
 * */ var getTotalPendingForUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(userId, userType, service_charge, deposit_percentage) {
        var count, coll, q, querySnapshot, coll1, q1, querySnapshot1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    count = 0;
                    if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Chef */ .Z.Chef)) return [
                        3,
                        3
                    ];
                    coll = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "proposals");
                    q = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .query */ .IO)(coll, (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("chefUid", "==", userId), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("proposalState", "in", [
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].AWAITING_PAYMENT */ .Z.AWAITING_PAYMENT,
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID
                    ]));
                    return [
                        4,
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDocs */ .PL)(q)
                    ];
                case 1:
                    querySnapshot = _state.sent();
                    return [
                        4,
                        Promise.all(querySnapshot.docs.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposal) {
                                var data, taxDetails, ref, ref1, ref2, ref3, ref4, ref5;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = proposal.data();
                                            return [
                                                4,
                                                fetchTransactionDetails(proposal.id)
                                            ];
                                        case 1:
                                            taxDetails = _state.sent();
                                            if (data.proposalState === _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].AWAITING_PAYMENT */ .Z.AWAITING_PAYMENT) {
                                                if (taxDetails) {
                                                    ;
                                                    ;
                                                    count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateGrossTotal */ .Z4)((ref1 = (ref = data.invoice) === null || ref === void 0 ? void 0 : ref.total) !== null && ref1 !== void 0 ? ref1 : 0, 0.029, service_charge, userType);
                                                }
                                            }
                                            if (data.proposalState === _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID) {
                                                if (taxDetails) {
                                                    ;
                                                    ;
                                                    count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateGrossTotal */ .Z4)((ref5 = (ref2 = data.invoice) === null || ref2 === void 0 ? void 0 : ref2.total) !== null && ref5 !== void 0 ? ref5 : 0 - (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateDepositPayment */ .Fr)((ref4 = (ref3 = data.invoice) === null || ref3 === void 0 ? void 0 : ref3.total) !== null && ref4 !== void 0 ? ref4 : 0, deposit_percentage), 0.029, service_charge, userType);
                                                }
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(proposal) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 3:
                    if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Client */ .Z.Client)) return [
                        3,
                        6
                    ];
                    coll1 = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "proposals");
                    q1 = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .query */ .IO)(coll1, (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("clientUid", "==", userId), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("proposalState", "in", [
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].AWAITING_PAYMENT */ .Z.AWAITING_PAYMENT,
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID
                    ]));
                    return [
                        4,
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDocs */ .PL)(q1)
                    ];
                case 4:
                    querySnapshot1 = _state.sent();
                    return [
                        4,
                        Promise.all(querySnapshot1.docs.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposal) {
                                var data, gigDoc, gig, gigData, taxDetails, _budget;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = proposal.data();
                                            gigDoc = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .doc */ .JU)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "gigs"), data.gigId);
                                            return [
                                                4,
                                                (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDoc */ .QT)(gigDoc)
                                            ];
                                        case 1:
                                            gig = _state.sent();
                                            gigData = gig.data();
                                            return [
                                                4,
                                                fetchTransactionDetails(proposal.id)
                                            ];
                                        case 2:
                                            taxDetails = _state.sent();
                                            if (taxDetails) {
                                                ;
                                                count += (_budget = gigData.budget) !== null && _budget !== void 0 ? _budget : 0;
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(proposal) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        count
                    ];
            }
        });
    });
    return function getTotalPendingForUser(userId, userType, service_charge, deposit_percentage) {
        return _ref.apply(this, arguments);
    };
}();
var getTotalPaidForUser = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(userId, userType, service_charge) {
        var count, coll, q, querySnapshot, coll1, q1, querySnapshot1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    count = 0;
                    if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Chef */ .Z.Chef)) return [
                        3,
                        3
                    ];
                    coll = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "proposals");
                    q = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .query */ .IO)(coll, (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("chefUid", "==", userId), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("proposalState", "in", [
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID,
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FINISHED_AND_PAID */ .Z.FINISHED_AND_PAID
                    ]));
                    return [
                        4,
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDocs */ .PL)(q)
                    ];
                case 1:
                    querySnapshot = _state.sent();
                    return [
                        4,
                        Promise.all(querySnapshot.docs.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposal) {
                                var data, taxDetails, ref, ref1, ref2, ref3;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = proposal.data();
                                            return [
                                                4,
                                                fetchTransactionDetails(proposal.id)
                                            ];
                                        case 1:
                                            taxDetails = _state.sent();
                                            if (!taxDetails) {
                                                return [
                                                    2
                                                ];
                                            }
                                            if (data.proposalState == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FINISHED_AND_PAID */ .Z.FINISHED_AND_PAID) {
                                                ;
                                                ;
                                                count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateGrossTotal */ .Z4)((ref1 = (ref = data.invoice) === null || ref === void 0 ? void 0 : ref.total) !== null && ref1 !== void 0 ? ref1 : 0, 0.029, service_charge, userType);
                                            }
                                            if (data.proposalState == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID) {
                                                ;
                                                ;
                                                count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateInitialGrossTotal */ .np)((ref3 = (ref2 = data.invoice) === null || ref2 === void 0 ? void 0 : ref2.total) !== null && ref3 !== void 0 ? ref3 : 0, 0.029, service_charge, userType);
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(proposal) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 2:
                    _state.sent();
                    return [
                        3,
                        6
                    ];
                case 3:
                    if (!(userType === _constants_UserType__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Client */ .Z.Client)) return [
                        3,
                        6
                    ];
                    coll1 = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "proposals");
                    q1 = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .query */ .IO)(coll1, (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("clientUid", "==", userId), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("proposalState", "in", [
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID,
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FINISHED_AND_PAID */ .Z.FINISHED_AND_PAID,
                        _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PENDING */ .Z.PENDING
                    ]));
                    return [
                        4,
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDocs */ .PL)(q1)
                    ];
                case 4:
                    querySnapshot1 = _state.sent();
                    return [
                        4,
                        Promise.all(querySnapshot1.docs.map(function() {
                            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposal) {
                                var ref, ref1, ref2, data, taxDetails, ref3, ref4, ref5, ref6;
                                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            data = proposal.data();
                                            return [
                                                4,
                                                fetchTransactionDetails(proposal.id)
                                            ];
                                        case 1:
                                            taxDetails = _state.sent();
                                            if (!taxDetails) {
                                                return [
                                                    2
                                                ];
                                            }
                                            if (data.proposalState == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FINISHED_AND_PAID */ .Z.FINISHED_AND_PAID || data.proposalState == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PENDING */ .Z.PENDING && ((ref = data.proposalHistory) === null || ref === void 0 ? void 0 : ref.previousState) == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID) {
                                                ;
                                                ;
                                                count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateGrossTotal */ .Z4)((ref4 = (ref3 = data.invoice) === null || ref3 === void 0 ? void 0 : ref3.total) !== null && ref4 !== void 0 ? ref4 : 0, 0.029, service_charge, userType);
                                            }
                                            if (data.proposalState == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].DEPOSIT_PAID */ .Z.DEPOSIT_PAID || data.proposalState === _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PENDING */ .Z.PENDING && (((ref1 = data.proposalHistory) === null || ref1 === void 0 ? void 0 : ref1.previousState) == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].AWAITING_PAYMENT */ .Z.AWAITING_PAYMENT || ((ref2 = data.proposalHistory) === null || ref2 === void 0 ? void 0 : ref2.previousState) == _constants_ProposalState__WEBPACK_IMPORTED_MODULE_1__/* ["default"].OPEN_BID */ .Z.OPEN_BID)) {
                                                ;
                                                ;
                                                count += (0,_helper_finance__WEBPACK_IMPORTED_MODULE_3__/* .calculateInitialGrossTotal */ .np)((ref6 = (ref5 = data.invoice) === null || ref5 === void 0 ? void 0 : ref5.total) !== null && ref6 !== void 0 ? ref6 : 0, 0.029, service_charge, userType);
                                            }
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                            return function(proposal) {
                                return _ref.apply(this, arguments);
                            };
                        }()))
                    ];
                case 5:
                    _state.sent();
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        count
                    ];
            }
        });
    });
    return function getTotalPaidForUser(userId, userType, service_charge) {
        return _ref.apply(this, arguments);
    };
}();
var getTaxDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposalId, amount) {
        var response;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_utils_api_helpers__WEBPACK_IMPORTED_MODULE_8__/* .fetchGetJSON */ .EE)("/api/payment/get-tax-stripe?proposalId=".concat(proposalId, "&amount=").concat(amount))
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response
                    ];
            }
        });
    });
    return function getTaxDetails(proposalId, amount) {
        return _ref.apply(this, arguments);
    };
}();
var fetchTransactionDetails = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(proposalId) {
        var queryData, docs, error;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    queryData = (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .query */ .IO)((0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .collection */ .hJ)(_firebase__WEBPACK_IMPORTED_MODULE_5__.db, "transactions"), (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .where */ .ar)("proposal_id", "==", proposalId));
                    return [
                        4,
                        (0,firebase_firestore__WEBPACK_IMPORTED_MODULE_0__/* .getDocs */ .PL)(queryData)
                    ];
                case 1:
                    docs = _state.sent();
                    if (!docs.empty) {
                        return [
                            2,
                            docs.docs[0].data()
                        ];
                    }
                    return [
                        2
                    ];
                case 2:
                    error = _state.sent();
                    console.log(error);
                    return [
                        2
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchTransactionDetails(proposalId) {
        return _ref.apply(this, arguments);
    };
}();
var getPaymentReason = function(proposalState) {
    switch(proposalState){
        case ProposalState.DEPOSIT_PAID:
            return PAYMENT_REASON.SELECT_PROPOSAL;
        case ProposalState.FINISHED_AND_PAID:
            return PAYMENT_REASON.GIG_COMPLETION;
        default:
            return PAYMENT_REASON.SELECT_PROPOSAL;
    }
};



/***/ }),

/***/ 61855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RK": function() { return /* binding */ formatAmountForDisplay; }
/* harmony export */ });
/* unused harmony exports formatAmountForStripe, formatAmountFromStripe */
function formatAmountForDisplay(amount, currency) {
    var numberFormat = new Intl.NumberFormat([
        "en-US"
    ], {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol"
    });
    return numberFormat.format(amount);
}
function formatAmountForStripe(amount, currency) {
    var numberFormat = new Intl.NumberFormat([
        "en-US"
    ], {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol"
    });
    var parts = numberFormat.formatToParts(amount);
    var zeroDecimalCurrency = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            if (part.type === "decimal") {
                zeroDecimalCurrency = false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return zeroDecimalCurrency ? amount : Math.round(amount * 100);
}
function formatAmountFromStripe(amount, currency) {
    var numberFormat = new Intl.NumberFormat([
        "en-US"
    ], {
        style: "currency",
        currency: currency,
        currencyDisplay: "symbol"
    });
    var parts = numberFormat.formatToParts(amount);
    var zeroDecimalCurrency = true;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var part = _step.value;
            if (part.type === "decimal") {
                zeroDecimalCurrency = false;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return zeroDecimalCurrency ? amount : Math.round(amount / 100);
}


/***/ })

}]);